<p-dialog [(visible)]="visible" appendTo="body" [modal]="!deviceManager.isMobile" [closable]="true" [showHeader]="true" (onHide)="onHide()"
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          styleClass="select-pdf-dialog">
    <p-header>Select PDF</p-header>
    <p-tree [value]="foldersTree" selectionMode="single" [loading]="loading" [style]="{ 'width': '100%' }" [(selection)]="selectedNode" (onNodeExpand)="onFolderExpanded($event.node)">
        <ng-template let-node pTemplate="default">
            <div *ngIf="isFolderNode(node)" class="folder">
                <fa-icon [icon]="['fas', 'folder']" size="2x"></fa-icon>
                <span class="folder-name">{{node.label}}</span>
            </div>
            <div *ngIf="isPdfNode(node)" class="pdf">
                <fa-icon [icon]="['far', 'file-pdf']" size="2x"></fa-icon>
                <span class="pdf-label-text">{{node.label}}</span>
            </div>
        </ng-template>
    </p-tree>
    <ng-template pTemplate="footer">
        <button pButton type="button" class="ok-button" label="Use Selected PDF" icon="pi pi-check" (click)="onOk()" [disabled]="!selectedNode || !isPdfNode(selectedNode)"></button>
    </ng-template>
</p-dialog>
